import React from 'react';

const HeroIntroSection = ({ onStart }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-6 md:p-8 border border-border">
      <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-stretch">
        <div className="w-full md:w-44 lg:w-56 flex-shrink-0 rounded-lg border border-border bg-background/40 p-3 flex items-stretch justify-center">
          <img
            src="/assets/images/kkumhyeon_men.png"
            alt="kkumhyeon"
            className="w-full h-full object-cover"
            loading="eager"
            decoding="async"
          />
        </div>

        <div className="min-w-0 flex-1">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-3">
            서비스 소개 및 시작하기
          </h1>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed">
            꿈을 목표로 등록하고, 작은 챌린지를 하나씩 완료하며 현실로 만들어가는 서비스입니다. 지금 공개된 목표와 최신 인증을 둘러보고,
            로그인해서 나만의 꿈을 바로 시작해보세요.
          </p>

          <div className="mt-6">
            <div className="text-sm md:text-base font-heading font-semibold text-foreground mb-3">사용방법</div>
            <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
              <div className="flex items-start gap-3 p-4 rounded-md border border-border/50 bg-background/40">
                <div className="w-8 h-8 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary">1</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground">꿈&목표 등록</div>
                  <div className="text-xs text-muted-foreground caption mt-1">이루고 싶은 꿈을 목표로 저장하세요.</div>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 rounded-md border border-border/50 bg-background/40">
                <div className="w-8 h-8 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary">2</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground">작게 시작할 수 있는 챌린지 등록</div>
                  <div className="text-xs text-muted-foreground caption mt-1">오늘부터 바로 할 수 있는 작은 행동을 만들어보세요.</div>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 rounded-md border border-border/50 bg-background/40">
                <div className="w-8 h-8 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary">3</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground">챌린지 인증 기록하기</div>
                  <div className="text-xs text-muted-foreground caption mt-1">인증을 남기며 꾸준함을 눈에 보이게 쌓아가요.</div>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 rounded-md border border-border/50 bg-background/40">
                <div className="w-8 h-8 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary">4</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground">끝~ 꿈&목표에 가까워졌습니다</div>
                  <div className="text-xs text-muted-foreground caption mt-1">작은 성공이 모여 큰 변화를 만듭니다.</div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6">
            <button
              type="button"
              onClick={onStart}
              className="px-5 py-3 rounded-md bg-primary text-primary-foreground shadow-gaming-md hover:shadow-gaming-lg transition-gaming"
            >
              시작하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroIntroSection;
